import { render, staticRenderFns } from "./PaymentBillingRecordForm.vue?vue&type=template&id=6bc9a6f4&scoped=true"
import script from "./PaymentBillingRecordForm.vue?vue&type=script&lang=js"
export * from "./PaymentBillingRecordForm.vue?vue&type=script&lang=js"
import style0 from "./PaymentBillingRecordForm.vue?vue&type=style&index=0&id=6bc9a6f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc9a6f4",
  null
  
)

export default component.exports